(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import moment from 'moment';
import { ProfileManager } from '@kailona/core';

function mapToFHIRLeukocytes(labsData) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = labsData.date,
      leukocytes = labsData.leukocytes;

  if (!date || !leukocytes) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'laboratory',
        display: 'Laboratory'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '6690-2',
        display: 'Leukocytes'
      }],
      text: 'Leukocytes'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    valueQuantity: {
      value: parseFloat(leukocytes),
      unit: '10^3/μl',
      system: 'http://unitsofmeasure.org',
      code: '10^3/μl'
    }
  };
  var idMap = labsData.idMap;

  if (idMap && idMap.leukocytes) {
    observation.id = idMap.leukocytes;
  }

  return observation;
}

function mapToFHIRHemoglobin(labsData) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = labsData.date,
      hemoglobin = labsData.hemoglobin;

  if (!date || !hemoglobin) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'laboratory',
        display: 'Laboratory'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '718-7',
        display: 'Hemoglobin [Mass/volume] in Blood'
      }],
      text: 'Hemoglobin [Mass/volume] in Blood'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    valueQuantity: {
      value: parseFloat(hemoglobin),
      unit: 'g/dl',
      system: 'http://unitsofmeasure.org',
      code: 'g/dL'
    }
  };
  var idMap = labsData.idMap;

  if (idMap && idMap.hemoglobin) {
    observation.id = idMap.hemoglobin;
  }

  return observation;
}

function mapToFHIRPlatelets(labsData) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = labsData.date,
      platelets = labsData.platelets;

  if (!date || !platelets) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'laboratory',
        display: 'Laboratory'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '32623-1',
        display: 'Platelet mean volume [Entitic volume] in Blood by Automated count'
      }],
      text: 'Platelet mean volume [Entitic volume] in Blood by Automated count'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    valueQuantity: {
      value: parseFloat(platelets),
      unit: '10^3/μl',
      system: 'http://unitsofmeasure.org',
      code: '10^3/μl'
    }
  };
  var idMap = labsData.idMap;

  if (idMap && idMap.platelets) {
    observation.id = idMap.platelets;
  }

  return observation;
}

function mapToFHIRLymphocytes(labsData) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = labsData.date,
      lymphocytes = labsData.lymphocytes;

  if (!date || !lymphocytes) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'laboratory',
        display: 'Laboratory'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '26474-7',
        display: 'Lymphocytes mean volume [Entitic volume] in Blood by Automated count'
      }],
      text: 'Lymphocytes mean volume [Entitic volume] in Blood by Automated count'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    valueQuantity: {
      value: parseFloat(lymphocytes),
      unit: '10^3/μl',
      system: 'http://unitsofmeasure.org',
      code: '10^3/μl'
    }
  };
  var idMap = labsData.idMap;

  if (idMap && idMap.lymphocytes) {
    observation.id = idMap.lymphocytes;
  }

  return observation;
}

function mapToFHIRNeutrophils(labsData) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = labsData.date,
      neutrophils = labsData.neutrophils;

  if (!date || !neutrophils) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'laboratory',
        display: 'Laboratory'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '26499-4',
        display: 'Neutrophil mean volume [Entitic volume] in Blood by Automated count'
      }],
      text: 'Neutrophil mean volume [Entitic volume] in Blood by Automated count'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    valueQuantity: {
      value: parseFloat(neutrophils),
      unit: '10^3/μl',
      system: 'http://unitsofmeasure.org',
      code: '10^3/μl'
    }
  };
  var idMap = labsData.idMap;

  if (idMap && idMap.neutrophils) {
    observation.id = idMap.neutrophils;
  }

  return observation;
}

function mapToFHIREosinophils(labsData) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = labsData.date,
      eosinophils = labsData.eosinophils;

  if (!date || !eosinophils) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'laboratory',
        display: 'Laboratory'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '26449-9',
        display: 'Eosinophil mean volume [Entitic volume] in Blood by Automated count'
      }],
      text: 'Eosinophil mean volume [Entitic volume] in Blood by Automated count'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    valueQuantity: {
      value: parseFloat(eosinophils),
      unit: '10^3/μl',
      system: 'http://unitsofmeasure.org',
      code: '10^3/μl'
    }
  };
  var idMap = labsData.idMap;

  if (idMap && idMap.eosinophils) {
    observation.id = idMap.eosinophils;
  }

  return observation;
}

function mapToFHIRBasophils(labsData) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = labsData.date,
      basophils = labsData.basophils;

  if (!date || !basophils) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'laboratory',
        display: 'Laboratory'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '26444-0',
        display: 'Basophil mean volume [Entitic volume] in Blood by Automated count'
      }],
      text: 'Basophil mean volume [Entitic volume] in Blood by Automated count'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    valueQuantity: {
      value: parseFloat(basophils),
      unit: '10^3/μl',
      system: 'http://unitsofmeasure.org',
      code: '10^3/μl'
    }
  };
  var idMap = labsData.idMap;

  if (idMap && idMap.basophils) {
    observation.id = idMap.basophils;
  }

  return observation;
}

function mapToFHIRMonocytes(labsData) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = labsData.date,
      monocytes = labsData.monocytes;

  if (!date || !monocytes) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'laboratory',
        display: 'Laboratory'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '26484-6',
        display: 'Monocyte mean volume [Entitic volume] in Blood by Automated count'
      }],
      text: 'Monocyte mean volume [Entitic volume] in Blood by Automated count'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    valueQuantity: {
      value: parseFloat(monocytes),
      unit: '10^3/μl',
      system: 'http://unitsofmeasure.org',
      code: '10^3/μl'
    }
  };
  var idMap = labsData.idMap;

  if (idMap && idMap.monocytes) {
    observation.id = idMap.monocytes;
  }

  return observation;
}

function mapToFHIRSBCPanel(labsData, observationIds) {
  var fhirPatientId = ProfileManager.activePatientId;

  if (!fhirPatientId) {
    throw new Error('Invalid patient id');
  }

  var date = labsData.date;

  if (!date || !observationIds || !observationIds.length) {
    return null;
  }

  var observation = {
    resourceType: 'Observation',
    status: 'final',
    category: [{
      coding: [{
        system: 'http://hl7.org/fhir/ValueSet/observation-category',
        code: 'laboratory',
        display: 'Laboratory'
      }]
    }],
    code: {
      coding: [{
        system: 'http://loinc.org',
        code: '55429-5',
        display: 'Short blood count panel - Blood'
      }],
      text: 'Short blood count panel - Blood'
    },
    subject: {
      reference: "Patient/".concat(fhirPatientId)
    },
    effectiveDateTime: moment(date).utc().toISOString(),
    hasMember: observationIds.map(function (observationId) {
      return {
        reference: "Observation/".concat(observationId)
      };
    })
  };
  var idMap = labsData.idMap;

  if (idMap && idMap.panel) {
    observation.id = idMap.panel;
  }

  return observation;
}

export { mapToFHIRLeukocytes, mapToFHIRHemoglobin, mapToFHIRPlatelets, mapToFHIRLymphocytes, mapToFHIRNeutrophils, mapToFHIREosinophils, mapToFHIRBasophils, mapToFHIRMonocytes, mapToFHIRSBCPanel };
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(mapToFHIRLeukocytes, "mapToFHIRLeukocytes", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapToFHIR.js");
  reactHotLoader.register(mapToFHIRHemoglobin, "mapToFHIRHemoglobin", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapToFHIR.js");
  reactHotLoader.register(mapToFHIRPlatelets, "mapToFHIRPlatelets", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapToFHIR.js");
  reactHotLoader.register(mapToFHIRLymphocytes, "mapToFHIRLymphocytes", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapToFHIR.js");
  reactHotLoader.register(mapToFHIRNeutrophils, "mapToFHIRNeutrophils", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapToFHIR.js");
  reactHotLoader.register(mapToFHIREosinophils, "mapToFHIREosinophils", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapToFHIR.js");
  reactHotLoader.register(mapToFHIRBasophils, "mapToFHIRBasophils", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapToFHIR.js");
  reactHotLoader.register(mapToFHIRMonocytes, "mapToFHIRMonocytes", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapToFHIR.js");
  reactHotLoader.register(mapToFHIRSBCPanel, "mapToFHIRSBCPanel", "/home/runner/html/nextcloud/apps/ehr/js/plugins/laboratory/src/mappers/mapToFHIR.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();